<template>
  <div>
    <input
      type="text"
      name="dates"
      id="filterDateRangeCustom"
      v-if="dateid == 'card'"
    />
    <ag-dropdown
      ref="dropdown"
      :value="filterDate"
      :options="
        customDate
          ? dateOptions
          : dateOptions.filter((f) => f.value !== 'custom')
      "
      @onChangeDropdown="onDateChanged"
    />
  </div>
</template>

<script>
import AgDropdown from "@/components/ag-dropdown";
import dateOptions from "@/helpers/DateOptions";
import { mapStores } from "pinia";
import { useCommonStore } from "@/stores/common";
import moment from "moment";

export default {
  components: {
    AgDropdown,
  },
  props: {
    filters: {
      type: Object,
    },
    dateid: {
      type: String,
    },
    defaultValue: {
      type: Object,
    },
    customDate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dateOptions: dateOptions,
      selectedDate: "",
    };
  },
  computed: {
    filterDate() {
      const filterDate = this.filters.find((f) => f.type == "date");
      let selectedLabel = "";
      if (this.defaultValue) {
        selectedLabel = this.dateOptions.find(
          (f) => f.label == this.defaultValue
        );
        return selectedLabel;
      } else {
        selectedLabel = this.dateOptions.find(
          (f) => filterDate && f.label == filterDate.selectedLabel
        );
      }

      if (
        this.$router.currentRoute.value.fullPath.indexOf("alert-console") > -1
      ) {
        if (localStorage.getItem("alertDate")) {
          return JSON.parse(localStorage.getItem("alertDate"));
        }
      }

      return filterDate && filterDate.vmodel
        ? selectedLabel
          ? selectedLabel
          : this.dateOptions[4]
        : this.dateOptions[2];
    },
    ...mapStores(useCommonStore),
  },
  watch: {
    filterDate(value) {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.setValue(value);
      }
    },
  },
  methods: {
    onDateChanged(data) {
      if (data.value === "custom") {
        try {
          document.getElementById("filterDateRangeCustom").click();
        } catch (error) {
          console.log(error);
        }
      } else {
        (this.filters.find((f) => f.type == "date") || {}).vmodel = data.value;
        (this.filters.find((f) => f.type == "date") || {}).selectedLabel =
          data.label;
      }

      if (
        this.$router.currentRoute.value.fullPath.indexOf("alert-console") > -1
      ) {
        localStorage.setItem("alertDate", JSON.stringify(data));
      }
      this.$emit("onDateChanged", data);
    },
  },
};
</script>

<style lang="scss" scoped>
#filterDateRangeCustom {
  visibility: hidden;
  position: absolute;
}
</style>
